import React from "react";
import "./dot.scss";

const Dot = ({ color = "#001978", size = 18 }) => {
  const reducedSize = size * 0.70;

  return (
    <div
      style={{
        border: `2px solid var(--white)`,
        width: `${size}px`,
        height: `${size}px`
      }}
      className={"dotComponentContainer"}
    >
      <span
        style={{
          backgroundColor: color,
          width: `${reducedSize}px`,
          height: `${reducedSize}px`
        }}
        className={"dotComponent"} />
    </div>
  );
};

export default Dot;
